import React, { createContext, useContext, useMemo } from "react";
import { useQuery } from "react-query";
import useGlobalContext from "hooks/globalData";
import contextStore from "stores/contextStore";

type CustomThemeContextType = {
  logoImageUrl?: string;
  logoAlternativeText?: string;
};

const CustomThemeContext = createContext<CustomThemeContextType>({});

export const useCustomThemeContext = () => useContext(CustomThemeContext);

type CustomThemeProviderProps = {
  children: React.ReactNode;
};

const CustomThemeProvider = ({ children }: CustomThemeProviderProps) => {
  const { siteSettingService } = useGlobalContext();
  const organizationId = contextStore.useState((s) => s.organizationId);

  const { data } = useQuery(
    "getSiteSettings",
    () => siteSettingService.getSiteSettings(),
    { staleTime: Infinity, enabled: !!organizationId }
  );

  const value = useMemo(
    () => ({
      logoImageUrl: data?.theme?.logoUrl ?? undefined,
      logoAlternativeText: data?.theme?.logoAlternativeText ?? undefined,
    }),
    [data?.theme]
  );

  return (
    <CustomThemeContext.Provider value={value}>
      {children}
    </CustomThemeContext.Provider>
  );
};

export default CustomThemeProvider;
